import React from 'react';
import { Box, Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const ReviewSectionSkeleton = () => (
  <Box>
    {[...Array(3).keys()].map((item) => (
      <Box my={2} key={item}>
        <Grid container spacing={2}>
          <Grid item lg={8} md={12} xs={12}>
            <Skeleton
              variant="text"
              width="100px"
              height={40}
              sx={{ display: 'inline-block', marginRight: '8px' }}
            />
            <Skeleton
              variant="text"
              width="50px"
              height={40}
              sx={{ display: 'inline-block' }}
            />
          </Grid>
          <Grid
            item
            lg={4}
            xs={12}
            sx={{ display: { lg: 'flex', md: 'block', xs: 'block' } }}
            justifyContent="flex-end">
            <Skeleton variant="text" width="80px" height={40} />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item lg={8} md={12} xs={12}>
            <Skeleton
              variant="circular"
              width="50px"
              height="50px"
              sx={{ display: 'inline-block' }}
            />
            <Box sx={{ display: 'inline-block', marginLeft: '8px' }}>
              <Skeleton variant="text" width="100px" height={30} />
              <Skeleton variant="text" width="50px" height={20} />
            </Box>
          </Grid>
          <Grid
            item
            lg={4}
            xs={12}
            sx={{ display: { lg: 'flex', md: 'block', xs: 'block' } }}
            justifyContent="flex-end">
            <Skeleton
              variant="text"
              width="80px"
              height={40}
              sx={{ display: 'inline-block', marginRight: '8px' }}
            />
            <Skeleton
              variant="text"
              width="80px"
              height={40}
              sx={{ display: 'inline-block', marginRight: '8px' }}
            />
            <Skeleton
              variant="text"
              width="80px"
              height={40}
              sx={{ display: 'inline-block' }}
            />
          </Grid>
        </Grid>
        <Skeleton variant="text" width="30%" height={30} />
        <Skeleton variant="text" width="80%" height={30} />
        <Skeleton variant="text" width="60%" height={30} />
        <Grid container spacing={2}>
          <Grid item lg={8} md={12} xs={12}>
            <Skeleton variant="text" width="300px" height={30} />
          </Grid>
          <Grid
            item
            lg={4}
            xs={12}
            sx={{ display: { lg: 'flex', md: 'block', xs: 'block' } }}
            justifyContent="flex-end">
            <Skeleton
              variant="text"
              width="20px"
              height={30}
              sx={{ display: 'inline-block', marginRight: '8px' }}
            />
            <Skeleton
              variant="text"
              width="20px"
              height={30}
              sx={{ display: 'inline-block' }}
            />
          </Grid>
        </Grid>
        <Skeleton
          variant="text"
          width="100%"
          height="2px"
          sx={{ marginTop: '16px' }}
        />
      </Box>
    ))}
  </Box>
);
export { ReviewSectionSkeleton };
